import BasicResource from '@/api/resource';

class BlacklistControlResource extends BasicResource {
    constructor () {
        super('query-filtering');
    }

    partnerList (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/partners`,
            params,
        });
    }

    partnerBlacklistOffers (partnerId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/partners/${partnerId}/offers`,
            params,
        });
    }

    partnerBlacklistAdvertisers (partnerId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/partners/${partnerId}/advertisers`,
            params,
        });
    }

    partnerBlacklistAffpubIds (partnerId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/partners/${partnerId}/affpubids`,
            params,
        });
    }

    partnerBlacklistParameters (partnerId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/partners/${partnerId}/parameters`,
            params,
        });
    }

    getPartnerBlacklist (partnerId) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/partners/${partnerId}`,
        });
    }

    updatePartnerBlacklist (partnerId, data, options) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/partners/${partnerId}`,
            data,
        }, options);
    }

    deletePartnerBlacklist (partnerId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/partners/${partnerId}`,
        });
    }

    retrievePartnerBlacklist (partnerId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/partners/${partnerId}/retrieve`,
        });
    }

    tspList (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/tracking-links`,
            params,
        });
    }

    getTspBlacklist (tspId) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/tracking-links/${tspId}`,
        });
    }

    updateTspBlacklist (tspId, data, options) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/tracking-links/${tspId}`,
            data,
        }, options);
    }

    deleteTspBlacklist (tspId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/tracking-links/${tspId}`,
        });
    }

    retrieveTspBlacklist (tspId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/tracking-links/${tspId}/retrieve`,
        });
    }

    tspBlacklistAffpubIds (tspId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/tracking-links/${tspId}/affpubids`,
            params,
        });
    }

    tspBlacklistParameters (tspId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/tracking-links/${tspId}/parameters`,
            params,
        });
    }

    deleteBlacklistItem (itemId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/${itemId}`,
        });
    }

    retrieveBlacklistItem (itemId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${itemId}/retrieve`,
        });
    }
}

export default new BlacklistControlResource;
